import { NavLink } from "react-router-dom";

import { useUser } from "@/hooks/useUser";
import type { Papel } from "@/types/api";

interface NavItem {
  to: string;
  label: string;
  allowed: Papel[];
}

const items: NavItem[] = [
  { to: "/", label: "Início", allowed: ["admin", "auditor", "compras", "farmaceutico", "enfermeira_chefe", "enfermagem"] },
  { to: "/medicamentos", label: "Catálogo", allowed: ["admin", "auditor", "compras", "farmaceutico", "enfermeira_chefe", "enfermagem"] },
  { to: "/pacientes", label: "Pacientes", allowed: ["admin", "auditor", "farmaceutico", "enfermeira_chefe", "enfermagem"] },
  { to: "/nfs", label: "Notas Fiscais", allowed: ["admin", "auditor", "compras", "farmaceutico"] },
  { to: "/requisicoes", label: "Requisições", allowed: ["admin", "farmaceutico", "enfermeira_chefe", "enfermagem"] },
  { to: "/dispensacoes", label: "Dispensações", allowed: ["admin", "farmaceutico", "enfermeira_chefe", "enfermagem"] },
  { to: "/devolucoes", label: "Devoluções", allowed: ["admin", "compras", "farmaceutico", "enfermeira_chefe"] },
  { to: "/entrada-estoque", label: "Movimentações s/ NF", allowed: ["admin", "farmaceutico"] },
  { to: "/caixas", label: "Caixas / Kits", allowed: ["admin", "auditor", "farmaceutico"] },
  { to: "/livro", label: "Livro Controlados", allowed: ["admin", "auditor", "farmaceutico"] },
  { to: "/relatorios", label: "Relatórios", allowed: ["admin", "auditor", "farmaceutico"] },
];

const adminItems: NavItem[] = [
  { to: "/admin/unidades", label: "Unidades", allowed: ["admin", "auditor"] },
  { to: "/admin/locais", label: "Locais de Estoque", allowed: ["admin", "auditor"] },
  { to: "/admin/composicao-kits", label: "Composição de Kits", allowed: ["admin", "farmaceutico"] },
  { to: "/admin/audit-recipients", label: "Audit Semanal", allowed: ["admin", "auditor"] },
];

export function NavSidebar() {
  const { data: user } = useUser();
  const papel = user?.papel;

  function visible(it: NavItem) {
    return !papel || it.allowed.includes(papel);
  }

  const link = "block rounded-md px-3 py-2 text-sm font-medium text-ink hover:bg-anarosa-50 hover:text-anarosa-700";
  const active = "bg-anarosa text-white hover:bg-anarosa-600 hover:text-white";

  return (
    <aside className="w-64 shrink-0 border-r border-gray-200 bg-white">
      <div className="border-b border-gray-200 px-6 py-5">
        <span className="font-display text-lg font-semibold text-anarosa">Med-Supply</span>
        <p className="text-xs text-ink-muted">Grupo Ana Rosa</p>
      </div>
      <nav className="p-3 space-y-1">
        {items.filter(visible).map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.to === "/"}
            className={({ isActive }) => `${link} ${isActive ? active : ""}`}
          >
            {it.label}
          </NavLink>
        ))}

        {adminItems.filter(visible).length > 0 ? (
          <>
            <div className="mt-6 mb-2 px-3 text-xs uppercase tracking-wider text-ink-subtle">
              Admin
            </div>
            {adminItems.filter(visible).map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                className={({ isActive }) => `${link} ${isActive ? active : ""}`}
              >
                {it.label}
              </NavLink>
            ))}
          </>
        ) : null}
      </nav>
    </aside>
  );
}
